import type { AxiosInstance } from 'axios'
import type { AppProblem } from './problem'

export type ProblemHandler = (problem: AppProblem) => void

let globalProblemHandler: ProblemHandler | undefined

export function setGlobalProblemHandler(handler: ProblemHandler | undefined): void {
  globalProblemHandler = handler
}

function handleRejection(error: unknown) {
  const problem = toProblem(error)

  if (isAmbientProblem(problem) && globalProblemHandler) {
    try {
      globalProblemHandler(problem)
      markProblemNotified(problem)
    } catch {
      // a broken handler must never mask the original rejection
    }
  }

  return Promise.reject(error)
}

export function installProblemInterceptor(instance: AxiosInstance): number {
  return instance.interceptors.response.use(response => response, handleRejection)
}
